// ** Icons Import
import { FileText } from 'react-feather'

export default [
  {
    id: 'sales',
    title: 'Sales  ',
    icon: <FileText size={20} />,
    navLink: 'transaction/sales'
  }
]
